// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconArchive, IconBriefcase, IconFriends, IconNotes, IconSchool, IconTool } from '@tabler/icons';

// constant
const icons = {
    IconSchool,
    IconNotes,
    IconBriefcase,
    IconFriends,
    IconTool,
    IconArchive
};

// ==============================|| PERSONAL - MENU ITEMS ||============================== //

const personal = {
    id: 'personal-route',
    title: <FormattedMessage id="SYS00001" />,
    type: 'group',
    children: [
        {
            id: 'personal-guardians',
            title: <FormattedMessage id="GUA00001" />,
            type: 'item',
            url: '/anagrafiche/tutori',
            icon: icons.IconFriends
        },
        {
            id: 'personal-students',
            title: <FormattedMessage id="STU00001" />,
            type: 'item',
            url: '/anagrafiche/alunni',
            icon: icons.IconSchool
        },
        {
            id: 'personal-teachers',
            title: <FormattedMessage id="TEA00001" />,
            type: 'item',
            url: '/anagrafiche/insegnanti',
            icon: icons.IconBriefcase
        },
        {
            id: 'forms-services',
            title: <FormattedMessage id="SER00001" />,
            type: 'item',
            url: '/anagrafiche/servizi',
            icon: icons.IconNotes
        },
        {
            id: 'personal-archive',
            title: <FormattedMessage id="ARC00001" />,
            type: 'item',
            url: '/archivio/anagrafiche',
            icon: icons.IconArchive
        }
    ]
};

export default personal;